import React from "react";
import { Checkbox, TableCell, TableRow } from "@mui/material";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import moment from "moment";

import {
  formatLength,
  images,
  showNotification,
  truncateString,
} from "../../../../constants";
import StatusDropdown from "../../../../common/StatusDropdown";
import { updateReaction } from "../../hooks/ReactionsHooks";
import { useReactionsContext } from "../../../../providers/OrganizationAdmin/ReactionsProvider";
import { Toast } from "../../../../common/alert";

const TableRowSection = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  setSelectedAudioFile,
  setSelectedImage,
  handleImagePreviewModalOpen,
  handleAudioModalOpen,
  columnWidths,
}) => {
  const { handleGetAllReactions, setLoading, loading } = useReactionsContext();

  const handleUpdateReactionStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        status,
      };
      console.log(status, row.id);
      let responseTemp = await updateReaction(row.id, dataTemp);
      console.log("update reaction response:", responseTemp);
      await handleGetAllReactions();
      showNotification("Reaction updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating reaction", error.message);
    } finally {
      setLoading(false);
    }
  };

  const dropdownOptions = ["approved", "pending", "denied"];

  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        // scope="row"
        padding="none"
        title={row?.quicktaleData?.title}
        style={{
          ...tableCellStyles,
          width: columnWidths?.["quicktaleData.title"] || 200,
          minWidth: columnWidths?.["quicktaleData.title"] || 200,
          maxWidth: columnWidths?.["quicktaleData.title"] || 200,
        }}
        // style={{ ...tableTitleFieldStyles }}
      >
        {row?.quicktaleData?.title &&
          truncateString(row?.quicktaleData?.title, 20)}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.["userData.userName"] || 170,
          minWidth: columnWidths?.["userData.userName"] || 170,
          maxWidth: columnWidths?.["userData.userName"] || 170,
        }}
      >
        {row?.userData?.userName || "Guest - " + row?.displayName || "Guest"}
      </TableCell>
      <TableCell
        align="center"
        // onClick={handleAudioModalOpen}
        onClick={() => {
          setSelectedAudioFile(row?.processedAudioUrl || row?.audioUrl);
          handleAudioModalOpen();
        }}
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.audio || 120,
          minWidth: columnWidths?.audio || 120,
          maxWidth: columnWidths?.audio || 120,
        }}
      >
        <PlayCircleFilledWhiteOutlinedIcon
          fontSize="large"
          style={{ color: "#00A7CD" }}
        />
      </TableCell>

      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.id || 120,
          minWidth: columnWidths?.id || 120,
          maxWidth: columnWidths?.id || 120,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        title={row?.id}
      >
        {row.id}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          width: columnWidths?.status || 170,
          minWidth: columnWidths?.status || 170,
          maxWidth: columnWidths?.status || 170,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <StatusDropdown
          options={dropdownOptions}
          currentValue={row?.status}
          onChange={handleUpdateReactionStatus}
        />
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdAt || 170,
          minWidth: columnWidths?.createdAt || 170,
          maxWidth: columnWidths?.createdAt || 170,
        }}
      >
        {row?.createdAt &&
          moment.unix(row.createdAt.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.["quicktaleData.audioLength"] || 100,
          minWidth: columnWidths?.["quicktaleData.audioLength"] || 100,
          maxWidth: columnWidths?.["quicktaleData.audioLength"] || 100,
        }}
      >
        {row?.audioLength && formatLength(row?.audioLength)}
      </TableCell>
      <TableCell
        align="center"
        padding="none"
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.photo || 90,
          minWidth: columnWidths?.photo || 90,
          maxWidth: columnWidths?.photo || 90,
        }}
        // onClick={handleImagePreviewModalOpen}
        onClick={() => {
          setSelectedImage(
            row?.quicktaleData?.imageUrls && row?.quicktaleData?.imageUrls[0]
              ? row?.quicktaleData?.imageUrls[0]
              : images.QuicktaleLogo
            // row?.quicktaleData?.photoUrl
            //   ? row?.quicktaleData?.photoUrl
            //   : images.QuicktaleLogo
          );
          handleImagePreviewModalOpen();
        }}
      >
        <img
          src={
            row?.quicktaleData?.imageUrls && row?.quicktaleData?.imageUrls[0]
              ? row?.quicktaleData?.imageUrls[0]
              : images.QuicktaleLogo
          }
          // src={
          //   row?.quicktaleData?.photoUrl
          //     ? row?.quicktaleData?.photoUrl
          //     : images.QuicktaleLogo
          // }
          // src={images.tableDummyImage}
          alt="table image"
          style={{ width: 45, height: 40 }}
        />
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.quicktale || 120,
          minWidth: columnWidths?.quicktale || 120,
          maxWidth: columnWidths?.quicktale || 120,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',

        }}
        title={row?.quicktale}
      >
        {row?.quicktale}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.["qtCreatedByData.userName"] || 220,
          minWidth: columnWidths?.["qtCreatedByData.userName"] || 220,
          maxWidth: columnWidths?.["qtCreatedByData.userName"] || 220,
        }}
      >
        {row?.qtCreatedByData?.userName}
      </TableCell>
    </TableRow>
  );
};

export default TableRowSection;

const tableTitleFieldStyles = {
  // paddingLeft: 5,
  // fontWeight: 600,
  border: "1px solid #BABABA",
  color: "#00A7CD",
  fontFamily: "Avenir Book, sans-serif",
  paddingLeft: 10,
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  paddingLeft: 10,
};
const tableStatusCellStyles = {
  border: "1px solid #BABABA",
  cursor: "pointer",
  // fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
  paddingLeft: 10,
};
